import { toast } from "react-toastify";

export function toastOnError(err: APIResponse, customToastMessage?: string) {
	if (err?.httpStatus === 404) toast.error("Requested data is unavailable.");
	else if (err?.httpStatus !== 401) toast.error(customToastMessage || "Something went wrong. Try again later.");
}
